function NavbarButtom() {
    return (
        
        <footer>
                <div>طراحی و توسعه توسط <a href="http://rahkar.online">راهکار پرداز</a></div>

        </footer>
    )
}

export default NavbarButtom;